"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetDailyEnergySavingData = void 0;
const index_1 = require("../../index");
const useGetDailyEnergySavingData = (sensors, selectedHubId, days = 30, hubConfig) => {
    // Find the first power monitor sensor for the selected hub
    const powerMonitorSensor = sensors?.find((sensor) => sensor.type === index_1.SensorType.POWER && sensor.hubId === selectedHubId);
    const { data, loading, error } = (0, index_1.usePowerUsageEnergySavings)({
        sensorId: powerMonitorSensor?.id || '',
        days,
        enabled: !!powerMonitorSensor?.id,
        hubConfig,
    });
    return {
        data,
        loading,
        error,
        sensor: powerMonitorSensor,
    };
};
exports.useGetDailyEnergySavingData = useGetDailyEnergySavingData;
